































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import UserIconMenuComponent from "@/app/views/nubii/components/sidebar/components/userIconMenu.component.vue";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { GREEN, RED } from "@/resources/constants/busyReasons";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { i18n } from "@/resources/locales";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import ReasonSelectorComponent from "@/app/views/nubii/components/graphicClientOptions/components/reasonSelector.component.vue";
import feather from "feather-icons";
import { MIX_PANEL_CONSTANTS } from "@/resources/constants/mixpanel";
import { SPACE_TYPE } from "@/resources/constants/space";
import { HELP_AND_SUPPORT } from "@/resources/constants/helpAndSupport";

@Component({
  name: "sidebar-footer",
  components: { UserIconMenuComponent, ReasonSelectorComponent },
  directives: { ClickOutsideDirective },
})
export default class SidebarFooterComponent extends mixins(
  NotificationEvent,
  FloatMenuAnimation
) {
  feather = feather;
  compilation = moment(process.env.VUE_APP_DATE_COMPILATION)
    .utc()
    .format("DDMMYY.HHmm");
  version = process.env.VUE_APP_VERSION;
  GREEN = GREEN;
  RED = RED;
  SPACE_TYPE = SPACE_TYPE;
  city = false;
  mounted(): void {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
  }
  get user() {
    return this.$store.getters["UserStore/getUser"];
  }
  get spaceUser(): any {
    if (this.city) {
      const data = {
        user: this.$store.getters["UserStore/getUser"],
      };
      return data;
    } else return this.$store.getters["UserStore/getSpaceUser"];
  }
  set spaceUser(spaceUser) {
    this.$store.dispatch("UserStore/setSpaceUserLocal", spaceUser);
  }
  get getEnterInNetworking(): boolean {
    return this.$store.getters["SpeedNetworkingStore/getEnterInNetworking"];
  }
  get getIsCall(): boolean {
    return this.$store.getters["SidebarStore/getOpenCall"];
  }
  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  graphicClientVersion(): string {
    return this.$store.getters["SystemStore/getGraphicClientVersion"];
  }
  showOpenReasonSelector() {
    return this.$store.getters["FloatMenuStore/getOpenReasonSelector"];
  }
  openReason(): void {
    setTimeout(() => {
      this.$store.dispatch("FloatMenuStore/setOpenReasonSelectorAction", true);
    }, 50);
    setTimeout(() => {
      this.openReasonSelector();
    }, 200);
  }
  closeReason(): void {
    setTimeout(() => {
      this.closeReasonSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch("FloatMenuStore/setOpenReasonSelectorAction", false);
    }, 200);
  }
  showNotification(): void {
    this.onWarning(
      i18n.t(""),
      i18n.t("notifications.warningMessages.stateIsNotChangedOnCall"),
      "none"
    );
  }
  updateWorkInOffice(): void {
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.spaceUser.superSpaceUser.user.id,
      props: {
        workInOffice: !this.spaceUser.superSpaceUser.user.workInOffice,
      },
      callback: (user) => {
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.userUpdate")
        );
        let newSpaceUser = this.spaceUser;
        newSpaceUser.superSpaceUser.user.workInOffice = user.workInOffice;
        this.spaceUser = newSpaceUser;
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
      },
      callbackError: (error) => {
        this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  updateStatus(): void {
    if (this.getIsCall || this.getEnterInNetworking) {
      this.showNotification();
      return;
    }
    this.openReason();
  }
  /*updateStatus(): void {
    if (this.getIsCall || this.getEnterInNetworking) {
      this.showNotification();
      return;
    }
    const props =
      this.spaceUser.superSpaceUser.user.availableStatus === RED.type
        ? {
            availableStatus: GREEN.type,
            availableStatusReason: null,
            emoji: localStorage.getItem("default_emoji"),
          }
        : {
            availableStatus: RED.type,
            availableStatusReason: null,
          };
    this.$store.dispatch("UserStore/updateUserStatusAction", {
      userId: this.spaceUser.superSpaceUser.user.id,
      props,
      callback: (user) => {
        if (user.availableStatus === RED.type) {
          this.openReason();
        }
        const space = this.$store.getters["SpaceStore/getSpace"];
        this.$mixpanel.track(
          user.availableStatus === GREEN.type
            ? MIX_PANEL_CONSTANTS.STATE_ON
            : MIX_PANEL_CONSTANTS.STATE_OFF,
          {
            distinct_id: this.spaceUser.superSpaceUser.user.id,
            "Space ID": space.id || null,
            "Space Name": space.name || null,
            "Space Type": space.type || null,
            "Scenario Name": space.scenario.scenarioType.name || null,
            "Super Space Name": space.superSpace.name || null,
            "Super Space ID": space.superSpace.id || null,
          }
        );

        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
      },
    });
  }*/
  showHelp(): void {
    //this.$store.dispatch("FloatMenuStore/setOpenHelpBotAction", true);
    let subject = i18n.t("sidebar.footer.help").toString();
    const mailtoLink = `mailto:${encodeURIComponent(HELP_AND_SUPPORT.EMAIL)}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailtoLink;
  }
  defaultSpot(): void {
    const user = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/saveSpaceUserDefaultPositiontAction", {
      userId: user.id,
      callback: () => {
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.assignedMyPlaceDefault")
        );
      },
    });
  }
}
